<template>
  <div class="addressValidate">
    <div class="card">
      <div class="title">{{$t('User.addressVerifi')}}</div>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-position="top"
      >
        <el-row
          :gutter="20"
        >
          <el-col
            :xs="24"
            :sm="12"
            :md="8"
          >
            <el-form-item
              prop="liveCountry"
              :label="$t('User.homeCountryCode')"
            >
              <el-select
                style="width: 100%"
                class="nationality"
                v-model="form.liveCountry"
                :placeholder="phFileter('root.selectPls')"
              >
                <el-option
                  v-for="(item, index) in nationalityList"
                  :key="index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
<!--国家省市区四级实现不了, 因为移动端时不够宽度, -->
          <el-col
            v-if="form.liveCountry == 1"
            :xs="24"
            :sm="12"
            :md="8"
          >
            <el-form-item
              v-if="form.liveCountry == 1"
              :label="$t('area')"
              class="area-form-item"
            >
              <template
                v-if="realMobile"
              >
                <div class="area-box">
                  <span
                    v-if="mobileAreaNullFlag"
                    @click="mobileAreaNullFlagHandle"
                  >{{$t('mobileAreaTips')}}</span>
                  <span class="pointer" @click="mobileAreaNullFlagHandle">{{province}} {{city}} {{area}}</span>
                </div>
                <v-distpicker
                  :placeholder="phFileter('User.plsInputAddress')"
                  type="mobile"
                  @selected='selected'
                  v-show="vDistpickerShow"
                  class="area1"
                  :province="province"
                  :city="city"
                  :area="area"
                >
                </v-distpicker>
              </template>
              <template
                v-else
              >
                <!---->
                <area-cascader
                  class="region"
                  type="text"
                  :level="1"
                  :placeholder="phFileter('User.plsInputAddress')"
                  :data="regionData"
                  v-model='form.region'
                ></area-cascader>
              </template>
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            :md="8"
          >
            <el-form-item
              :label="$t('Detailed_address_local_language')"
              prop="address"
            >
              <el-input
                :placeholder="$t('please_input')"
                v-model="form.address"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
<!--缩小窗口时,有个多余的位置 todo-->
        <el-row>
          <el-col
            :span="24"
          >
            <h5 class="h5-el">{{$t('Upload_supporting_documents')}}</h5>
            <p class="address-tips"
              v-for="(item,index) in tipsList"
               :key="index"
            >{{item}}</p>
            <div style="height: 15px;"></div>
            <div class="tips-box">
              <i class="el-icon-info icon-el"></i>
              <span class="tips-text">{{$t('Make_sure_the_document_shows_your_full_name_full_address_and_the_time_it_was_issued_or_is_vali')}}</span>
            </div>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
          >
            <div class="demo-box right-demo">
              <div class="img-out">
                <img
                  :style="demoImgStyle"
                  class="image-el"
                  src="../../assets/images/customer/auth/por-do.png" alt="">
              </div>
              <div class="img-right">
                <h3 class="subtitle">{{$t('Demonstrate_correctly')}}</h3>
                <ol>
                  <li
                    class="dot-li"
                    v-for="(item,index) in passportRightTips"
                    :key="index"
                  >
                    <span class="dot"></span>
                    {{item}}
                  </li>
                </ol>
              </div>
            </div>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
          >
            <div class="demo-box wrong-demo">
              <div class="img-out">
                <img
                  :style="demoImgStyle"
                  class="image-el"
                  src="../../assets/images/customer/auth/por-dont.png"
                  alt="">
              </div>
              <div class="img-right">
                <h3 class="subtitle">{{$t('Error_demonstration')}}</h3>
                <ol>
                  <li
                    class="dot-li"
                    v-for="(item,index) in wrongTips"
                    :key="index"
                  >
                    <span class="dot"></span>
                    {{item}}
                  </li>
                </ol>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col
            :span="4"
            :xs="24"
          >
            <el-form-item
              :label="$t('certified_documents')"
              prop="addressImgUrl"
            >
              <upload-img-tips></upload-img-tips>
              <el-upload
                class="avatar-uploader"
                action="''"
                :accept="$config.imgFormat"
                :show-file-list="false"
                :http-request="uploadFront"
                :before-upload="beforeAvatarUpload"
                v-loading="addressLoading"
              >
                <img
                  v-if="form.addressImgUrl"
                  :src="form.addressImgUrl"
                  class="avatar middle"
                >
                <div v-else class="avatar-uploader-btn idimg">
                  <i  class="el-icon-plus avatar-uploader-icon"></i>
                  <span class="id-img-desc">{{$t('Support_jpg_or_png_format')}}</span>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="btn-line">
      <vs-button
        color="primary"
        type="border"
        class="next-btn"
        @click="prevHandle">{{$t('root.upper')}}</vs-button>
      <vs-button @click="nextHandle">{{$t('root.next')}}</vs-button>
    </div>
  </div>
</template>

<script>
import { savePerfectInfoStep } from '@/api/userCenter.js';
import { changeTimestamp,limitImageSizeFormat } from '@/utils/common';
import{ showMessage } from '@/utils/common';
import VDistpicker from 'v-distpicker';
import { mapGetters } from 'vuex'
import apcaa from '@/areaData/index'; // 国家
import { pca, pcaa } from 'area-data';

export default {
  name: "addressValidate",
  components: {
    VDistpicker
  },
  props: {
    allData:{
      type: Object,
      default(){
        return {}
      }
    },
    nationalityList:{
      type: Array,
      default(){
        return []
      }
    }
  },
  data() {
    let _this = this;
    return {
      // 三级联动,手机端start
      province: '',
      city: '',
      area: '',
      addInpMobile: false,
      mask: false,
      // 三级联动,手机端end
      form: {
        liveCountry: '1',
        region: [], // 默认是1
        address: '',
        addressImgUrl: '', // todo
      },
      rules: {
        liveCountry:[
          { required: true, message: _this.$t('please_choose'), trigger: 'change' },
        ],
        region:[
          { required: true, message: _this.$t('please_choose'), trigger: 'change' },
        ],
        address:[
          { required: true, message: _this.$t('please_input'), trigger: 'blur' },
        ],
        addressImgUrl:[
          { required: true, message: _this.$t('Please_upload'), trigger: 'change' },
        ],
      },
      tipsList: [
        _this.$t('Please_upload_one_of_the_following_proof_of_address_documents'),
        _this.$t('ID_card'),
        _this.$t('driver_license'),
        _this.$t('Property_bills_such_as_electricity_bills_water_bills_gas_bills_etc'),
        _this.$t('Internet_cable_telephone_bill'),
        _this.$t('Bank_statements'),
        _this.$t('credit_card_bill'),
        _this.$t('residence_permit'),
        _this.$t('Affidavit_Certificate_of_Residence'),
        _this.$t('Household_register'),
        _this.$t('Any_government_issued_documents'),
      ],

      passportRightTips: [
        _this.$t('Photos_are_clear'),
        _this.$t('Details_clearly_visible'),
        _this.$t('Photo_quality'),
        _this.$t('All_four_corners_of_the_document_are_visible'),
      ],
      wrongTips: [
        _this.$t('Photo_is_blurry_and_out_of_focus'),
        _this.$t('Details_not_shown_clearly'),
        _this.$t('Photo_quality_is_low_too_dark_or_too_bright'),
        _this.$t('All_four_corners_not_shown'),
      ],

      addressLoading: false,
    }
  },
  watch: {
    allData(news, olds) {
      this.form.liveCountry = !news.homeCountryCode ? '1' : news.homeCountryCode;

      this.form.region = [];
      this.form.region.push(news.homeProvince,news.homeCity,news.homeStreet);

      this.province = news.homeProvince;
      this.city = news.homeCity;
      this.area = news.homeStreet;
      this.form.address = news.homeAddress; //详细地址
      this.form.addressImgUrl = news.addressImgUrl;
    }
  },
  computed: {
    ...mapGetters(['realMobile','userInfo']),

    demoImgStyle(){
      return {
        width: '190px',
        height: '157px',
      }
    },
    regionData() {
      return pcaa;
      // return apcaa;
    },
    mobileAreaNullFlag(){
      if(this.realMobile){
        if(!this.province && !this.city && !this.area){
          return true;
        }else {
          return false;
        }
      }else {
        return false;
      }
    },
    vDistpickerShow(){
      if(this.realMobile){
        return this.addInpMobile;
      }else {
        return true;
      }
    },
  },
  methods: {
    changeTimestamp,
    phFileter(data){
      return this.$t(data);
    },
    mobileAreaNullFlagHandle(){
      this.addInpMobile = true;
      this.mask = true;
    },
    // 省市区三级联动
    selected(data) {
      this.mask = false;
      this.addInpMobile = false;
      this.province = data.province.value;
      this.city = data.city.value;
      this.area = data.area.value;
    },

    // 上传图片的限制
    beforeAvatarUpload(file){
      return limitImageSizeFormat(file,this);
    },
    // 上传地址证名
    uploadFront(item){
      this.$getBase64(item.file).then(res => {
        let file = this.$base64toFile(res);

        this.addressLoading = true;
        this.$uploadFile(file).then((res) => {
          this.addressLoading = false;
          this.form.addressImgUrl = res.data.data.content[0].url;
        }).catch((err) => {
          this.addressLoading = false;
        })
      });

    },
    prevHandle(){
      this.$emit('prev-step');
    },
    getParams(){
      let Parmas = {
        homeCountryCode: this.form.liveCountry,
        homeProvince: this.form.region[0],
        homeCity: this.form.region[1],
        homeStreet: this.form.region[2],
        homeAddress: this.form.address,
        addressImg: this.form.addressImgUrl,
      };
      if(this.realMobile){
        Parmas.homeProvince = this.province;
        Parmas.homeCity = this.city;
        Parmas.homeStreet = this.area;
      }
      return Parmas;
    },
    nextHandle(){
      this.$refs.form.validate((valid,message) => {
        if (valid) {
          if(this.realMobile){
            if(this.form.liveCountry ==  '1'){
              if(!this.province && !this.city && !this.area){
                showMessage(this,this.$t('User.regionNullMessage'));
                return;
              }
            }
          }else {
            if(this.form.liveCountry == '1'){
              if(!this.form.region.length || (this.form.region.length && !this.form.region[0])){
                showMessage(this,this.$t('User.regionNullMessage'));
                return;
              }
            }
          }



          savePerfectInfoStep({
            ...this.getParams(),
            profileProgress: 3,
            id: this.userInfo.id
          }).then((res) => {
            this.$emit('next-step');
          })
        } else {
          console.log('error submit!!');
          console.log(message);
          return false;
        }
      });

    },

  },
}
</script>

<style lang="scss" scoped>
.addressValidate {
  .tips-box {
    display: inline-block;
    background-color: rgba(186, 191, 199, 0.12);
    border-radius: 5px;
    padding: 10px;
    align-items: center;
    margin-bottom: 10px;
    .icon-el {
      margin-right: 10px;
      color: rgba(186, 191, 199, 1);
    }
  }
  .demo-box {
    margin-bottom: 26px;
    .img-out {
      margin-right: 20px;
      .image-el {

      }
    }
    .subtitle {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 12px;
      color: #D85E5F;
    }
    .dot-li {
      padding-left: 10px;
      position: relative;
      .dot {
        width: 4px;
        height: 4px;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        border-radius: 50%;
        background-color: #6E6B7B;
      }
    }
    &.right-demo {
      .subtitle {
        color: #41B883;
      }
    }
  }
  .avatar-uploader {
    .avatar {
      width: 200px;
      height: 120px;
    }
  }
  .area1{
    width: 100%;
    height: 45%;
    position:fixed;
    left: 0;
    bottom: 0;
    overflow-y: scroll;
    z-index: 99;
  }
}
</style>
<style lang="scss">
.addressValidate {
  .area-form-item {
    .area-select.large {
      width: 100% !important;
      height: 40px;
      line-height: 40px;
      padding-left: 10px;
    }
    .area-select .area-selected-trigger {
      padding-top: 0;
    }
  }
  .area-box {
    border: 1px solid #DCDFE6;
    border-radius: 5px;
    padding-left: 10px;
  }
}
</style>
